import { InjectionFeature } from '@/common/reward/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { validateDate, validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';
import { Options } from './mixins';

export function usePromotionCodeAdd() {
    const route = useRoute();
    const router = useAppRouter();

    const model = reactive({
        id: null,
        feature: StringUtils.toNumber(route.query.feature),
        data: StringUtils.toNumber(route.query.data),
        name: '',
        code: '',
        status: null,
        quantity: 0,
        receiveLimit: -1,
        receiveCounter: 0,
        startTime: new Date(),
        endTime: new Date(),
        canEnable: false,
        canDisable: false,
        canDelete: false,

        get dataOption(): Array<any> {
            switch (this.feature) {
                case InjectionFeature.ArenaTicket:
                    return Options.arenas;
                case InjectionFeature.ScratchTicket:
                    return Options.scratchTickets;
                default:
                    return [{ label: this.data, value: this.data }];
            }
        }
    });

    const validations = {
        feature: { required },
        data: { required },
        name: { required },
        code: { required },
        quantity: { required, integer, minValue: minValue(1) },
        receiveLimit: { required, integer, minValue: minValue(-1) },
        startTime: { required, validateDate: validateDate(), validateDateAfter: validateDateAfter() },
        endTime: { required, validateDate: validateDate(), validateDateAfter: validateDateAfter('startTime') }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            promotionService.code.create(
                model.name,
                model.code,
                model.feature,
                model.data,
                model.quantity,
                model.receiveLimit,
                model.startTime.getTime(),
                model.endTime.getTime()
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_PROMOTION.CODE.INDEX })
    });

    return { model, v$, Options, create };
}
